import { render } from "./Festival.vue?vue&type=template&id=b46a7b10"
import script from "./Festival.vue?vue&type=script&lang=js"
export * from "./Festival.vue?vue&type=script&lang=js"

import "./Festival.vue?vue&type=style&index=0&id=b46a7b10&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__